import MemberActionTypes from './types';

export const fetchMembersStart = searchQuery => ({
  type: MemberActionTypes.FETCH_MEMBERS_START,
  payload: searchQuery,
});

export const nextPage = () => ({
  type: MemberActionTypes.NEXT_PAGE,
});

export const prevPage = () => ({
  type: MemberActionTypes.PREV_PAGE,
});

export const filterMembers = (dateFrom, dateTo) => ({
  type: MemberActionTypes.FILTER_MEMBERS,
  payload: { dateFrom, dateTo },
});

export const setMemberState = state => ({
  type: MemberActionTypes.SET_MEMBER_STATE,
  payload: state,
});
